<template>
    <div id="frameUp">
        <div class="fondo"></div>
        <div class="contenido show">
            <div v-if="servicio === 'empresa'">
               <Empresa />
            </div>
        </div>
    </div>
</template>

<script>
   import {mapActions, mapMutations, mapState} from 'vuex'
   import Empresa from "../Servicios/Empresa/Empresa";

    export default {
        name: "FramePage",
       components: {Empresa},
       computed: {
          ...mapState([
             'servicio'
          ]),
       }
    }
</script>

<style scoped lang="scss">
    @import "../../style/base";

    #frameUp{
        position: absolute;
        width: 100%;
        min-width: 400px;
        height: 100%;
        z-index: 200;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;


        & .fondo {
            position: fixed;
            width: 100%;
            height: 100%;
            background: #152033;
            opacity: .4;
            z-index: 999;
        }

        & .contenido {
            position: relative;
            width: 90%;
            background: #FFFFFF;
            height: 0%;
            bottom: 0;
            z-index: 1001;
            @include flexColumn;
            overflow: auto;

            &.show {
                animation: showFrame 2s linear;
                height: 100%;
                margin: 0 auto;
            }

            &.closeFrame {
                animation: closeFrame 2s linear;
                height: 0;
                margin: 0;
            }

            @keyframes showFrame {
                0% { position: absolute; height: 0%; margin: 0; }
                100% { position: absolute; height: 100%; margin: 0 6%; }
            }

            @keyframes closeFrame {
                0% { position: absolute; height: 100%; margin: 0 5%; }
                100% { position: absolute; height: 0%; margin: 0; }
            }

        }

    }

</style>